import React, { useState } from 'react';

import type { IProps } from './models';
import { Star } from './stars/star';

const initial = -1;

export const Rating = ({ onChange, stars, styles, value, withHelpText }: IProps) => {
    const [preValue, setPreValue] = useState<number>(initial);
    const checkedStar = stars.findIndex(el => el === value);

    return (
        <div className={styles.question}>
            <div
                className={styles.ratingWrapper}
                onMouseLeave={/* istanbul ignore next */ () => setPreValue(initial)}
            >
                {stars.map((val, index) => (
                    <Star
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${index}${val}`}
                        dataTestId={`feedback-form-star${index}`}
                        isChecked={checkedStar >= index}
                        isIncreasing={preValue >= checkedStar}
                        isPreChecked={preValue >= index}
                        onClick={() => {
                            onChange(val);
                            // костыль. Видимо из-за анимации не отрабатывает onMouseLeave контейнера
                            setPreValue(initial);
                        }}
                        onMouseEnter={() => setPreValue(index)}
                    />
                ))}
            </div>
            {!value && withHelpText && (
                <div className={styles.ratingHelpText}>Нажмите для оценки</div>
            )}
        </div>
    );
};
